import gql from "graphql-tag";

// DeleteProjectSpecialConditionTypeMapping + the project's trail row in ONE document, so a removal
// leaves a history line the same way a save does.
//
// The where clause names no revision on purpose: the delete permission's filter already carries
// `revision: { frozen_at: { _is_null: true } }`, so this only ever reaches the working state's row
// and the archive copies on frozen revisions are unreachable from a client. That guard is what
// makes a projectId/model/typeIdentifier filter safe on a revision-scoped table.
const DeleteProjectSpecialConditionTypeMappingWithVersionMutation = gql`
  mutation DeleteProjectSpecialConditionTypeMappingWithVersion(
    $projectId: uuid!
    $model: String!
    $typeIdentifier: String!
    $version: projectVersion_insert_input!
  ) {
    delete_projectSpecialConditionTypeMapping(
      where: { projectId: { _eq: $projectId }, model: { _eq: $model }, typeIdentifier: { _eq: $typeIdentifier } }
    ) {
      affected_rows
    }
    insert_projectVersion_one(object: $version) {
      id
    }
  }
`;

export default DeleteProjectSpecialConditionTypeMappingWithVersionMutation;
